import React from "react";
import { Routes, Route } from "react-router-dom";
import VirtualOfficePage from "./VirtualOfficePage";
import TeamWorkspaceLayout from "../Team/components/TeamWorkspaceLayout";
import { TEAM_BASE } from "../../utils/teamNavigation";

export default function TeamVirtualOfficeRoutes({ basePath = TEAM_BASE, standalone = false }) {
  return (
    <TeamWorkspaceLayout
      basePath={basePath}
      activeSection="virtualOffice"
      contentScroll
      standalone={standalone}
    >
      <Routes>
        <Route index element={<VirtualOfficePage />} />
      </Routes>
    </TeamWorkspaceLayout>
  );
}
